import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGhat } from "../ghatModel";
import moment from "moment";

export const createGhat = createAsyncThunk(
  "Ghat/NewInsertGhat",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/NewInsertGhat`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateGhat = createAsyncThunk(
  "Ghat/NewUpdateGhat",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/NewUpdateGhat`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteGhat = createAsyncThunk(
  "Ghat/DeleteGhat",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/DeleteGhat`,
        { ghat_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllGhat = createAsyncThunk(
  "Ghat/FindAllGhat",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/FindAllGhat`,
        formData,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting Ghat", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getGhatById = createAsyncThunk(
  "Ghat/NewFindByIDGhat",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/NewFindByIDGhat`,
        { ghat_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        ghat_guid: result.ghat_guid,
        issue_no: result.issue_no,
        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        address: result.address,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        // approx_delivery_date: result.approx_delivery_date
        //   ? moment(result.approx_delivery_date).toDate()
        //   : "",
        karigarIdWiseOutStandingAmount: result.karigarIdWiseOutStandingAmount,
        SizeDetails: result.SizeDetails,
        given_amount: result.given_amount,
        remarks: result.remarks,
        ghat_item: result.ghat_item
          ? result.ghat_item.map((gitem: any) => {
              return {
                id: gitem.id,
                order_no: gitem.order_no,
                approx_delivery_date: gitem.approx_delivery_date
                  ? moment(gitem.approx_delivery_date, "YYYY-MM-DD").toDate()
                  : "",
                ghat_id: gitem.ghat_id,
                order_id: gitem.order_id,
                item_id: gitem.item_id,
                item_name: gitem.item_name,
                item_category_id: gitem.item_category_id,
                category_name: gitem.category_name,
                item_subcategory_id: gitem.item_subcategory_id,
                item_subcategory_name: gitem.item_subcategory_name,
                size: gitem.size,
                color: gitem.color,
                purity_id: gitem.purity_id,
                purity: gitem.purity,
                priority: gitem.priority,
                Carat: gitem.Carat,
                ProcessImage: gitem.ProcessImage,
                weight: gitem.weight,
                remarks: gitem.remarks,
                process_id: gitem.process_id,
                approval_items: gitem.approval_items?.length
                  ? gitem.approval_items?.map((approvalItem: any) => {
                      return {
                        ...approvalItem,
                        IssueDate: approvalItem.IssueDate
                          ? moment(
                              approvalItem.IssueDate,
                              "YYYY-MM-DD",
                            ).toDate()
                          : null,
                      };
                    })
                  : [],
                ghatprocessimage: gitem.ghatprocessimage
                  ? gitem.ghatprocessimage.map((image: any) => {
                      return {
                        id: image.id,
                        item_id: image.item_id,
                        process_id: image.process_id,
                        image_name: image.image_name,
                      };
                    })
                  : [],
              };
            })
          : [],
        ghat_gold_issues: result.ghat_gold_issues
          ? result.ghat_gold_issues.map((results: any) => {
              return {
                id: results.id,
                IssueDate: results?.IssueDate
                  ? moment(results.IssueDate, "YYYY-MM-DD").toDate()
                  : null,
                ghat_id: results.ghat_id,
                item_id: results.item_id,
                item_name: results.item_name,
                given_weight: results.given_weight,
                given_purity: results.given_purity,
                given_wastage: results.given_wastage,
                phine: results.phine,
                pcs: results.pcs,
              };
            })
          : [],
      } as unknown as IGhat;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteGhatItems = createAsyncThunk(
  "Ghat/DeleteGhatItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/DeleteGhatItem`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghat ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGhadiaIssueItems = createAsyncThunk(
  "Ghat/DeleteGhatItemIssue",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/DeleteGhatItemIssue`,
        { id: ID },
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghadia Issue ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGoldIssueItems = createAsyncThunk(
  "Ghat/DeleteGhatGoldItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/DeleteGhatGoldItem`,
        { id: ID },
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Gold Issue ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGhatApprovalItem = createAsyncThunk(
  "Ghat/DeleteGhatApprovalItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ghat/DeleteGhatApprovalItem`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghadia Issue ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
